exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article-container[data-v-2c421b33]{max-width:1200px;margin:0 auto}.avatar-uploader .el-upload[data-v-2c421b33]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden;transition:all .3s;width:300px;height:200px}.avatar-uploader .el-upload[data-v-2c421b33]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-2c421b33]{font-size:28px;color:#8c939d;width:300px;height:200px;line-height:200px;text-align:center}.cover-image[data-v-2c421b33]{width:100%;height:100%;display:block;object-fit:cover}.editor-container[data-v-2c421b33]{height:400px;border:1px solid #d9d9d9;border-radius:4px}.mt-10[data-v-2c421b33]{margin-top:10px}.mt-20[data-v-2c421b33]{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c421b33","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Article.vue
// module id = E3Xr
// module chunks = 1